const STORAGE_KEY = 'admin.sideNav.collapsed'

/**
 * Whether the admin left rail was last left collapsed to icons. A per-browser convenience, so
 * a missing or blocked `localStorage` simply means "expanded" — never an error.
 */
export const readSideNavCollapsed = (): boolean => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const writeSideNavCollapsed = (isCollapsed: boolean): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(isCollapsed))
  } catch {
    // Storage unavailable (private mode, blocked site data): the rail still toggles for the
    // session, it just will not be remembered.
  }
}
